import { Box, Text } from '@hopskipdrive/react-components';
import { MenuItem } from '@mui/material';
import styled from 'styled-components';

import { colorPalette, colorTokens } from '../../../shared/components/variables';

export const StatusSelectContainer = styled(Box)`
  && {
    .MuiInputBase-root {
      border-radius: 4px;
    }

    .MuiSelect-select {
      padding: 6px 8px;
      padding-right: 32px;
    }

    &.open {
      .MuiInputBase-root {
        border: 1px solid ${colorTokens.error.outlineBorder} !important;
        background-color: ${colorTokens.error.buttonHover};
      }
    }

    &.resolved {
      .MuiInputBase-root {
        border: 1px solid ${colorTokens.success.outlineBorder} !important;
        background-color: ${colorTokens.success.buttonHover};
      }
    }
  }
`;

export const StatusMenuItem = styled(MenuItem)`
  && {
    padding: 6px 8px;
    background-color: transparent !important;

    .status {
      border-radius: 4px;
      padding: 2px 4px;
    }
  }
`;

export const StyledStatus = styled(Box)`
  display: flex;
  align-items: center;

  svg {
    width: 16px;
    height: 16px;
  }

  h6 {
    padding: 0 6px;
    text-transform: capitalize;
  }

  &.filled {
    border-radius: 4px;
    padding: 0px 4px;

    &.open {
      border: 1px solid ${colorTokens.error.outlineBorder} !important;
      background-color: ${colorTokens.error.buttonHover} !important;
    }

    &.resolved {
      border: 1px solid ${colorTokens.success.outlineBorder} !important;
      background-color: ${colorTokens.success.buttonHover} !important;
    }

    h6 {
      font-size: 14px !important;
    }
  }
`;

export const StatusMenuHeading = styled(Box)`
  padding: 8px;
  padding-bottom: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const CloseButton = styled(Text)`
  cursor: pointer;
  svg {
    height: 1rem;
    width: 1rem;
    color: ${colorPalette.neutral350};
  }
`;
